import React from "react";
import { ArrowRight, Shield, Code, Zap } from "lucide-react";
import { Globe } from "./ui/Globe";

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById("services");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="home"
      className="min-h-screen px-6 lg:px-10 w-full flex items-center justify-center
      bg-gradient-to-br from-white via-gray-100 to-[#f0fffe] bg-black  pt-20"
    >
      <Globe className="z-auto mt-16 mr-20 hidden md:block" />

      <div className="mx-auto max-w-7xl">
        <div className="grid relative lg:grid-cols-2 gap-14 xl:gap-20 items-center">
          {/* Left Content */}
          <div className="animate-fadeInLeft max-w-xl">
            {/* Eyebrow */}
            <div className="flex items-center space-x-3 mb-8">
              <div className="h-1 w-12 bg-[#2aa996]" />
              <span className="text-[#2aa996] font-semibold uppercase tracking-wider text-sm">
                AI-First Transformation
              </span>
            </div>

            {/* Headline */}
            <h1
              className="
                text-[2.75rem] sm:text-5xl lg:text-[3.75rem]
                leading-[1.1] lg:leading-[1.05]
                tracking-tight
                font-bold
                mb-10
              "
            >
              Building clarity in a changing world.
              {/* <span className="gradient-text px-2"> AI-First Innovation</span> */}
            </h1>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-5 mt-2 mb-16">
              <button
                onClick={scrollToContact}
                className="btn-primary flex items-center justify-center space-x-2 group"
              >
                <span>See Your AI Transformation Roadmap</span>
                <ArrowRight
                  className="group-hover:translate-x-1 transition-transform duration-300"
                  size={20}
                />
              </button>

              <button onClick={scrollToServices} className="btn-secondary">
                Explore Services
              </button>
            </div>
          </div>

          {/* Right Content */}
          <div className="animate-fadeInRight">
            <div className="relative space-y-7">
              {/* Card 1 */}
              <div className="glass-effect px-7 py-6 transform hover:scale-105 transition-all duration-300 cursor-pointer">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#2aa996] rounded-lg flex items-center justify-center shrink-0">
                    <Zap className="text-white" size={24} />
                  </div>
                  <div>
                    <h3 className="text-[1.05rem] font-semibold leading-snug mb-1">
                       Strategy & Consulting
                    </h3>
                    <p className="text-gray-600 text-[0.95rem] leading-relaxed">
                      Identify where AI delivers real value and build a clear,
                      executable roadmap to get there.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 2 */}
              <div className="glass-effect px-7 py-6 ml-8 transform hover:scale-105 transition-all duration-300 cursor-pointer">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#2aa996] rounded-lg flex items-center justify-center shrink-0">
                    <Code className="text-white" size={24} />
                  </div>
                  <div>
                    <h3 className="text-[1.05rem] font-semibold leading-snug mb-1">
                       Development & Software
                    </h3>
                    <p className="text-gray-600 text-[0.95rem] leading-relaxed">
                      Custom AI systems and software designed to evolve
                      alongside your business.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 3 */}
              <div className="glass-effect px-7 py-6 transform hover:scale-105 transition-all duration-300 cursor-pointer">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#2aa996] rounded-lg flex items-center justify-center shrink-0">
                    <Shield className="text-white" size={24} />
                  </div>
                  <div>
                    <h3 className="text-[1.05rem] font-semibold leading-snug mb-1">
                      Digital Transformation
                    </h3>
                    <p className="text-gray-600 text-[0.95rem] leading-relaxed">
                      Reimagine operations with AI-first thinking and modern,
                      scalable architectures.
                    </p>
                  </div>
                </div>
              </div>

              {/* Decorative Elements */}
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#2aa996] opacity-10 rounded-full blur-xl" />
              <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-[#2aa996] opacity-5 rounded-full blur-2xl" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
